﻿export class AANHorizontalScroll {
	init(): void {
		const scrollContainerNavs: HTMLElement[] = [].slice.call(document.querySelectorAll('.horizontal-scroll'))

		scrollContainerNavs.forEach((scrollContainerNav) => {
			const scrollId = scrollContainerNav.getAttribute("data-horizontal-scroll-for");
			const scrollContainer = document.querySelector(`*[data-horizontal-scroll-id="${scrollId}"]`)!;
			const scrollLeftButton = scrollContainerNav.querySelector('.next')!;
			const scrollRightButton = scrollContainerNav.querySelector('.previous')!;

			const currentUpdateButtonState = function () {
				updateButtonState(scrollContainer, scrollContainerNav, scrollLeftButton, scrollRightButton);
			};

			// Add event listeners to both buttons
			scrollLeftButton.addEventListener('click', () => {
				scrollContainer.scrollBy({ left: -scrollContainer.clientWidth, behavior: 'smooth' });
				currentUpdateButtonState();
			});

			scrollRightButton.addEventListener('click', () => {
				scrollContainer.scrollBy({ left: scrollContainer.clientWidth, behavior: 'smooth' });
				currentUpdateButtonState();
			});

			scrollContainer.addEventListener("scroll", currentUpdateButtonState);

			window.addEventListener("resize", currentUpdateButtonState);

			// Initial state update
			currentUpdateButtonState();
		});

		function updateButtonState(scrollContainer: Element, scrollContainerNav: Element, scrollLeftButton: Element, scrollRightButton: Element) {
			// Check if the scroll bar is necessary
			const isScrollable = scrollContainer.scrollWidth > scrollContainer.clientWidth;

			if (!isScrollable) {
				// If no scroll bar, hide both buttons
				scrollLeftButton.classList.add('hidden');
				scrollRightButton.classList.add('hidden');
				scrollContainerNav.classList.add('no-scroll');
				return; // No need to proceed further
			} else {
				// If scroll bar exists, ensure buttons are visible
				scrollLeftButton.classList.remove('hidden');
				scrollRightButton.classList.remove('hidden');
				scrollContainerNav.classList.remove('no-scroll');
			}

			// Disable the left button if scrolled to the start
			if (scrollContainer.scrollLeft === 0) {
				scrollLeftButton.classList.add('disabled');
			} else {
				scrollLeftButton.classList.remove('disabled');
			}

			// Disable the right button if scrolled to the end
			if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
				scrollRightButton.classList.add('disabled');
			} else {
				scrollRightButton.classList.remove('disabled');
			}
		}
	}
}


document.addEventListener("DOMContentLoaded", () => {
	const carousel = new AANHorizontalScroll();

	carousel.init();
});
